import seedrandom from "seedrandom"
let QuestionResponseMultipleChoiceView
require("./styles/question-response-multiple-choice.css")

const Utils = require("global/utils").default

export default QuestionResponseMultipleChoiceView = (function () {
  QuestionResponseMultipleChoiceView = class QuestionResponseMultipleChoiceView extends (
    require("lib/static-shim").default(require("./question-response").default)
  ) {
    static initClass() {
      this.prototype.template = require("./templates/question-response-multiple-choice.html")
      this.prototype.className = "question-response-multiple-choice-view"

      this.prototype.modelEvents = {
        "change:selected_option": "onOptionSelected"
      }
    }

    behaviors() {
      const behaviors = super.behaviors()
      return _.extend(behaviors, {
        // Have to do this before:bind to avoid
        // conflicts with mathjax syntax and rivets
        MathJax: {
          event: "before:bind"
        }
      })
    }

    initialize() {
      this._shown = false
      if (__guard__(this.model.get("selected_options"), (x) => x.length)) {
        return this.model.set(
          "selected_option",
          this.model.get("selected_options")[0],
          { trigger: false }
        )
      }
    }

    onBeforeModelSave(...args) {
      // Fail safe for ensuring option set if one is selected in the UI
      if (!this.model.get("selected_option")) {
        const selected_option = parseInt(
          this.$el.find("input:checked").first().val()
        )
        if (selected_option) {
          this.model.set({ selected_option })
        }
      }
    }

    onOptionSelected() {
      this.model.set("selected_options", [this.model.get("selected_option")])
      this.$(".mc-option").removeClass("selected")
      return this.$(
        `[data-id='${this.model.get("selected_option")}']`
      ).addClass("selected")
    }

    onRender() {
      return this.$el.toggleClass("answered", this.model.get("is_answered"))
    }

    onShow() {
      return (this._shown = true)
    }

    transitionAnswerSaved() {
      this.$(".feedback").hide()
      let duration = 300
      if (!this._shown) {
        duration = 1
      }
      if (this._shouldShowFeedback()) {
        if (this.model.get("is_answered_correctly")) {
          return this.$(".feedback-correct").velocity(
            "transition.shrinkIn",
            duration
          )
        } else {
          this.$(".feedback-incorrect")
            .show()
            .velocity("transition.fadeIn", duration)
          return this.$(".feedback-correct").velocity("transition.shrinkIn", {
            delay: duration / 2
          })
        }
      }
    }

    serializeData() {
      const data = super.serializeData()
      data.options = this._getOptions()
      return data
    }

    _getOptions() {
      // Adds "markup" data to answer options
      let options = this.question.get("options")
      if (this.assessment.get("randomize_choice_order")) {
        // Have to make sure we randomize the same way every time
        const seedKey = `mc-options-${this.question.id}`
        const randFunc = seedrandom(seedKey)
        options = new Utils().shuffleArray(
          this.question.get("options"),
          randFunc
        )
      }

      if (this._shouldShowFeedback()) {
        for (let op of Array.from(options)) {
          op.disabled = true
          op.selected_status = null
          op.is_selected = `${op.id}` === `${this.model.get("selected_option")}`
          if (op.is_selected || op.is_correct_answer) {
            op.selected_status =
              (op.is_correct_answer && "correct") || "incorrect"
          }
        }
      }
      return options
    }

    _getSelectedOptionEl() {
      return this.$(`li[data-id=${this.model.get("selected_option")}]`)
    }

    _getCorrectOptionEl() {
      return this.$(`li[data-id=${this._getCorrectOption().id}]`)
    }

    _getCorrectOption() {
      const options = this.question.get("options")
      const op = _.filter(options, { is_correct_answer: true })[0]
      return op
    }
  }
  QuestionResponseMultipleChoiceView.initClass()
  return QuestionResponseMultipleChoiceView
})()

function __guard__(value, transform) {
  return typeof value !== "undefined" && value !== null
    ? transform(value)
    : undefined
}
